import React, { useReducer, useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { set } from 'idb-keyval';
import PropTypes from 'prop-types';
import SDPContext from './Context';
import { GET_TOKEN, GET_USER } from './actionTypes';
import { initialState, combinedReducers } from './Reducer';

export default function SDPProvider({ children }) {
  const { keycloak, initialized } = useKeycloak();
  const [state, dispatch] = useReducer(combinedReducers, initialState);

  function registerTokenInApp() {
    const appToken =
      process.env.REACT_APP_ENV === 'local'
        ? process.env.REACT_APP_DEV_TOKEN
        : keycloak.token;

    set('token', appToken);
    dispatch({ type: GET_TOKEN, payload: appToken });
  }

  // faz o refesh do token a cada 5 segundos
  useEffect(() => {
    const refreshToken = setInterval(() => {
      if (initialized) {
        if (keycloak.authenticated) {
          keycloak.updateToken(5).then((refreshed) => {
            if (refreshed) registerTokenInApp();
          });
        }
      }
    }, 5000);

    return () => clearInterval(refreshToken);
  }, []);

  // inicia os dados do keycloak e persiste no estado do SDP Context
  useEffect(() => {
    let clearToken = () => {
      window.sessionStorage.removeItem('token');
      dispatch({ type: GET_TOKEN, payload: '' });
    };
    if (initialized) {
      if (keycloak.authenticated) {
        registerTokenInApp();
        keycloak.loadUserInfo().then((user) => {
          dispatch({ type: GET_USER, payload: user });
        });
      } else {
        clearToken();
      }
    }

    return clearToken;
  }, [initialized]);

  return (
    <SDPContext.Provider value={{ state, dispatch }}>
      {children}
    </SDPContext.Provider>
  );
}

SDPProvider.propTypes = {
  children: PropTypes.node.isRequired
};
